import React from 'react';
import styled from 'styled-components';
import enterpriseSearch from '../../assets/project/enterprise_search.png';

const MaetelProject = () => {
  return (
    <Container>
      <div className='box'>
        <div className='box-tag'>엔터프라이즈 검색 SaaS</div>
        <div className='box-heading'>모든 정보를 한곳에서.</div>
        <div className='box-detail'>
          <div className='box-desc-heading'>
            노션, 슬랙, 구글 서비스 등 산재되어 있는 데이터를 각 서비스의 로그인
            및 API 연동을 통해서 하나의 페이지에서 Elasticsearch 를 활용해
            검색하고 정리된 형태로 볼 수 있는 서비스
            <div className='box-desc-list'>
              <div className='box-desc-list-item'>
                Elasticsearch
                <br />
                인덱싱
              </div>
              <div className='box-desc-list-item'>
                슬랙 서드파티
                <br />앱 개발
              </div>
              <div className='box-desc-list-item'>
                기업별 OKR 관리 및<br />
                정보 공유 기능
              </div>
            </div>
          </div>
        </div>
        <div className='img-box'>
          <img
            src={enterpriseSearch}
            alt='enterprise search'
          />
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;

  .img-box {
    text-align: center;

    img {
      width: 240px;
    }
  }

  .box {
    background: linear-gradient(45deg, #1e3c72 30%, #11998e 100%);
    border-radius: 25px;
    text-align: left;
    padding: 40px;
  }

  .box-tag {
    margin-bottom: 40px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-sub-heading {
    font-size: 64px;
    font-weight: 700;
    margin: 0;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-desc-heading {
      color: #fff;
      margin-bottom: 8px;
    }

    .box-description {
      margin: 0;
    }

    .box-desc-list {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 48px;
      font-size: 36px;
      font-weight: 700;

      .box-desc-list-item {
        padding: 12px 18px;
        text-align: center;
      }
    }
  }

  @media only screen and (min-width: 769px) {
    .box-detail {
      .box-desc-list {
        font-size: 56px;
      }
    }

    .img-box {
      img {
        width: 540px;
      }
    }
  }
`;

export default MaetelProject;
